export default __webpack_public_path__ + "static/media/pof-virtualCard.f6333abe.png";